import {useEffect,useRef,useState} from 'react';

export default function useDiagramTransition(target,animate,resetToken) {
  const [value,setValue]=useState(target),current=useRef(target),reset=useRef(resetToken);
  useEffect(()=>{
    if(!animate||reset.current!==resetToken) {
      reset.current=resetToken;current.current=target;setValue(target);return;
    }
    const from=current.current;if(from===target)return;
    const start=Date.now(),timer=setInterval(()=>{
      const t=Math.min(1,(Date.now()-start)/220),eased=1-(1-t)**3;
      current.current=from+(target-from)*eased;setValue(current.current);
      if(t>=1)clearInterval(timer);
    },16);
    return ()=>clearInterval(timer);
  },[target,animate,resetToken]);
  return animate&&reset.current===resetToken?value:target;
}
